import { gql } from "@apollo/client";

export const CREATE_SUPPLIER = gql`
  mutation CreateSupplier($input: SupplierInput) {
    createSupplier(input: $input) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;

export const GET_SUPPLIER_PAGINATION = gql`
  query GetSupplierPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
    $isUse: Boolean
  ) {
    getSupplierPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
      isUse: $isUse
    ) {
      data {
        _id
        address
        email
        remark
        name
        tel
      }
      paginator {
        currentPage
        hasNextPage
        hasPrevPage
        next
        perPage
        prev
        slNo
        totalDocs
        totalPages
        totalPosts
      }
    }
  }
`;

export const UPDATE_SUPPLIER_IS_USE = gql`
  mutation UpdateSupplierIsUse($id: ID!, $isUse: Boolean) {
    updateSupplierIsUse(_id: $id, isUse: $isUse) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_SUPPLIER = gql`
  mutation UpdateSupplier($id: ID!, $input: SupplierInput) {
    updateSupplier(_id: $id, input: $input) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;

export const DELETE_SUPPLIER = gql`
  mutation DeleteSupplier($id: ID!) {
    deleteSupplier(_id: $id) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;

export const SELECT_SUPPLIER = gql`
    query SelectSupplier {
      selectSupplier {
        _id
        name
      }
  }
`;
